import { AnimatePresence } from 'framer-motion'

import { useMenuContext } from 'context/menu-context'
import { breakpoints } from 'styles/mq'
import { useMedia } from 'hooks/useMedia'
import { Sections } from './sections'
import { ChaptersList, CssVars, Number, StyledNav } from './styled'

export const Nav = () => {
  const { chapters, scrollToElement, visibleSection } = useMenuContext()
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)

  return (
    <StyledNav>
      <CssVars />
      <div>
        <AnimatePresence>
          {(!!visibleSection || isMobile) && (
            <ChaptersList
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              {chapters.map(chapter => {
                const activeSectionIndex = chapter.sections.findIndex(
                  s => s.isActive
                )
                const isActive = activeSectionIndex >= 0

                const handleClick = (
                  element: HTMLElement = chapter.sections[0]?.element
                ) => {
                  scrollToElement(element)
                }

                return (
                  <li key={chapter.title} data-active={isActive}>
                    <button disabled={isActive} onClick={() => handleClick()}>
                      {chapter.title}{' '}
                      <Number>
                        {chapter.sections.filter(c => !c.hidden).length}
                      </Number>
                    </button>

                    <AnimatePresence>
                      {activeSectionIndex > 0 && (
                        <Sections
                          key={chapter.title}
                          sections={chapter.sections}
                          onClick={handleClick}
                        />
                      )}
                    </AnimatePresence>
                  </li>
                )
              })}
            </ChaptersList>
          )}
        </AnimatePresence>
      </div>
    </StyledNav>
  )
}
